module.exports = "<p>\r\n  monitoreo works!\r\n</p>\r\n"